export enum Fields {
    STATUS = 'status',
    DOCUMENT_TYPE = 'documentType',
    DATE = 'documentDate',
    SENDER = 'sendBy',
}
